import { useRequest } from 'ahooks';
import { useEffect, useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { Tooltip } from 'antd'
import qs from 'qs';
import Loading from '../../components/Loading';
import TimeTD from '../../components/TimeTD';
import Pager from '../../components/Pager';
import EmptyTokenImg from '../../components/EmptyTokenImg';
import UserContext from '../../UserContext';

export default function TokentxnsErc721({ address, overview }) {
  const [showAs, setShowAs] = useState('Age');
  const userContext = useContext(UserContext);
  const user = userContext.user || {};
  const location = useLocation();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  const [state, setState] = useState({
    body: {
      start: query.p || '1',
      length: '25',
    },
  });
  const internalTradeListRequest = useRequest({
    url: '/blockBrowser/blockChain/contractInternalTrade/contractTrade721List',
    method: 'post',
    headers: {
      Authorization: user.token,
    },
    body: JSON.stringify({
      start: state.body.start,
      length: '25',
      field: 'address',
      value: address,
    }),
  });

  if (internalTradeListRequest.loading) {
    return <Loading />;
  }

  const data = internalTradeListRequest.data?.contract_trade_721_list || [];
  const counts = internalTradeListRequest.data?.counts || 0;
  const contract_trade_721_count = internalTradeListRequest.data?.contract_trade_721_count || 0;
  const totalPage = Math.ceil(Number(counts) / state.body.length);

  const changeType = () => {
    let str = showAs == 'Age' ? 'Date Time (UTC)' : 'Age'
    setShowAs(str)
  }

  return (
    <div className="tab-pane fade active show" role="tabpanel" aria-labelledby="events-tab">
      <div className="d-md-flex justify-content-between align-items-center mb-4">
        <p className="mb-2 mb-lg-0">
          <i className="fa fa-spin fa-spinner fa-1x fa-pulse" style={{ display: 'none', marginTop: '4px', marginRight: '4px' }}>
            &nbsp;
          </i>
          <i className="fas fa-sort-amount-down" data-toggle="tooltip" data-placement="bottom" title="Oldest First"></i>&nbsp;Latest {contract_trade_721_count} MRC-20 Token Transfer Events
        </p>
        <div className="d-flex flex-wrap flex-xl-nowrap text-nowrap align-items-center ml-auto">
          {
            parseInt(contract_trade_721_count) < parseInt(counts) ? <Pager path={`${window.location.pathname}`} hash={'#tokentxnsErc721'} current={state.body.start} total={totalPage} /> : undefined
          }
        </div>
        <nav className="mb-4 mb-md-0" aria-label="page navigation"></nav>
      </div>
      <div className="table-responsive">
        <table className="table table-md-text-normal table-hover">
          <thead className="thead-light">
            <tr>
              <th scope="col">
                Txn Hash
              </th>
              <th scope="col">
                <a href="#" title="" data-toggle-commonjs="tooltip" data-original-title="Click to show Datetime Format" onClick={changeType}>
                {showAs}
                </a>
              </th>
              <th scope="col">From</th>
              <th scope="col" width="30"></th>
              <th scope="col">To</th>
              <th scope="col">Token ID</th>
              <th scope="col">Token</th>
            </tr>
          </thead>
          <tbody>
            {data.map(item => {
              const time = moment(item.create_time).startOf('minute').fromNow();
              return (
                <tr key={item.order_no}>
                  <td>
                    <span className="hash-tag text-truncate">
                      <a href={`/tx/${item.trade_hash}`} target="_parent">
                        {item.trade_hash}
                      </a>
                    </span>
                  </td>
                  <TimeTD time={item.trade_time} interval={item.trade_time_interval} showAs={showAs} />
                  <td style={{ whiteSpace: 'nowrap' }}>
                    {item.public_from_tag ? (<Tooltip title={<span>{item.public_from_tag}<br />({item.trade_from})</span>}>
                      <a href={item.trade_from_type === 2 ? undefined : `/address/${item.trade_from}`}
                        className="hash-tag text-truncate"
                      >{item.public_from_tag}</a>
                    </Tooltip>) :
                      item.private_from_tag ? (<Tooltip title={<span>{<span>My Name Tag:{item.private_from_tag}<br /></span>}({item.trade_from})</span>}>
                        <a href={`/address/${item.trade_from}`}>
                          <span className='hash-tag text-truncate u-label u-label--value u-label--secondary text-dark my-n1'>{item.private_from_tag}</span>
                        </a>
                      </Tooltip>) :
                        (<Tooltip title={<span>{item.public_from_tag && <span>My Name Tag:{item.public_from_tag}<br /></span>}({item.trade_from})<br />{item.private_from_tag && <span>Public Tag:{item.private_from_tag}</span>}</span>}>
                          <a
                            href={item.trade_from_type === 2 ? undefined : `/address/${item.trade_from}`}
                            className={`hash-tag text-truncate${item.trade_from_type === 2 ? ' hash-tag--self' : ''}`}
                          >{item.trade_from}</a>
                        </Tooltip>)}
                  </td>
                  <td>
                    <span className={`u-label u-label--xs u-label--${item.trade_from_type === 2 ? 'warning' : 'success'} color-strong text-uppercase text-center w-100 rounded text-nowrap`}>
                      &nbsp;{item.trade_from_type === 2 ? 'OUT' : 'IN'}&nbsp;
                    </span>
                  </td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    {item.public_to_tag ? (<Tooltip title={<span>{item.public_to_tag}<br />({item.trade_to})</span>}>
                      <a href={item.trade_from_type == 2 ? `/address/${item.trade_to}` : undefined}
                        className="hash-tag text-truncate"
                      >{item.public_to_tag}</a>
                    </Tooltip>) :
                      item.private_to_tag ? (<Tooltip title={<span>{<span>My Name Tag:{item.private_to_tag}<br /></span>}({item.trade_to})</span>}>
                        <span className='hash-tag text-truncate u-label u-label--value u-label--secondary text-dark my-n1'>{item.private_to_tag}</span>
                      </Tooltip>) :
                        (<Tooltip title={<span>{item.public_to_tag && <span>My Name Tag:{item.public_to_tag}<br /></span>}({item.trade_to})<br />{item.private_to_tag && <span>Public Tag:{item.private_to_tag}</span>}</span>}>
                          <a
                            href={item.trade_from_type == 2 ? `/address/${item.trade_to}` : undefined}
                            className={`hash-tag text-truncate${item.trade_from_type === 2 ? '' : ' hash-tag--self'}`}
                          >{item.trade_to}</a>
                        </Tooltip>)}
                  </td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <span className="hash-tag text-truncate" data-boundary="viewport" data-html="true" data-toggle="tooltip" data-placement="bottom" title="" data-original-title={item.token_id}>
                      {parseInt(item.token_id, 16)}
                    </span>
                  </td>
                  <td>
                    <a href={`/token/${item.token_address}?a=${address}`} target="_parent">
                      <EmptyTokenImg src={item.token_image} width="13px" style={{ marginRight: '4px' }} />
                      {item.token_name}
                    </a>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {/* <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center text-secondary"></div>
        <div className="small text-muted">
          <span className="float-right" data-toggle="tooltip" title="Export records in CSV format">
            <font size="1">
              [ Download
              <a href={`/exportData?type=addresstokentxns&a=${address}`} className="mx-1" target="_blank">
                <b> CSV Export</b>
              </a>
              <span className="fas fa-download text-secondary"></span> ]
            </font>
          </span>
        </div>
      </div> */}
    </div>
  );
}
